import * as React from 'react';
import classNames from 'styles/utils/classNames';
import { getOptionFlowReadTags } from 'utils/shared/trades/getOptionFlowSideIntelligence';
import { getOptionFlowRowSentimentClassName } from 'utils/shared/trades/getOptionFlowRowSentiment';
import { Trade } from 'utils/shared/trades/types';

type OptionFlowTradeReadProps = {
  trade?: Partial<Trade> | null;
  className?: string;
  variant?: 'table' | 'popover';
};

const OptionFlowTradeRead: React.FC<OptionFlowTradeReadProps> = ({
  trade,
  className,
  variant = 'table',
}) => {
  const readTag = getOptionFlowReadTags(trade)[0];
  const sentimentClassName = getOptionFlowRowSentimentClassName(trade);

  if (!readTag) {
    return <span className="text-palette-black-7">-</span>;
  }

  return (
    <span
      title={readTag.tooltip}
      aria-label={`${readTag.label}: ${readTag.tooltip}`}
      className={classNames(
        'inline-flex min-w-0 max-w-full items-center justify-center truncate whitespace-nowrap rounded-[3px] border border-current bg-palette-black-3 font-semibold leading-none shadow-[inset_0_0_0_1px_rgba(255,255,255,0.02)]',
        variant === 'table' ? 'h-[18px] px-1.5 text-[0.6rem]' : 'h-5 px-2 text-[0.66rem]',
        sentimentClassName,
        className,
      )}
    >
      {readTag.label}
    </span>
  );
};

export default OptionFlowTradeRead;
